import "core-js/modules/es7.object.get-own-property-descriptors";
import "core-js/modules/es6.object.keys";
import "core-js/modules/web.dom.iterable";
import "core-js/modules/es6.regexp.split";
import _defineProperty from "/data/svn/trpc_mqq/b-7412685b9a7147d19e21e6f723ad7dbb/input/1709611215905/bin/src/node_modules/@babel/runtime-corejs2/helpers/esm/defineProperty.js";
import _classCallCheck from "/data/svn/trpc_mqq/b-7412685b9a7147d19e21e6f723ad7dbb/input/1709611215905/bin/src/node_modules/@babel/runtime-corejs2/helpers/esm/classCallCheck.js";
import _createClass from "/data/svn/trpc_mqq/b-7412685b9a7147d19e21e6f723ad7dbb/input/1709611215905/bin/src/node_modules/@babel/runtime-corejs2/helpers/esm/createClass.js";
import "core-js/modules/es6.regexp.replace";
function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }
function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }
/* eslint-disable camelcase */
import Boss from "./Boss";
import cookie from "./cookie";
import env from "./env";
import { globalObject } from "./system";
import { buildUrl } from "./url";
function getUin() {
  var uin = parseInt(cookie.get('uin').replace(/^o0*/g, ''), 10);
  if (!uin || uin <= 10000) {
    uin = parseInt(cookie.get('luin').replace(/^o0*/g, ''), 10);
    if (!uin || uin <= 10000) {
      return 0;
    }
  }
  return uin;
}
var Reporter = /*#__PURE__*/function () {
  function Reporter() {
    var bossId = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 0;
    var pwd = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : '';
    var useAtta = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : false;
    _classCallCheck(this, Reporter);
    if (!bossId || !pwd) {
      throw new Error('[Reporter] bossId and pwd is missing, please get it from boss platform.');
    }
    this.boss = new Boss({
      bossId: bossId,
      pwd: pwd,
      useAtta: useAtta
    });
    this._queue = [];
  }
  _createClass(Reporter, [{
    key: "init",
    value: function init() {
      var _globalObject$locatio, _globalObject$locatio2, _globalObject$locatio3, _globalObject$locatio4, _globalObject$documen;
      var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
      this.boss.setBaseUrl(buildUrl(this.boss.getBaseUrl(), _objectSpread({
        f_url: (_globalObject$locatio = globalObject.location) === null || _globalObject$locatio === void 0 ? void 0 : _globalObject$locatio.pathname,
        f_dm: (_globalObject$locatio2 = globalObject.location) === null || _globalObject$locatio2 === void 0 ? void 0 : _globalObject$locatio2.host,
        f_protocol: (_globalObject$locatio3 = globalObject.location) === null || _globalObject$locatio3 === void 0 ? void 0 : _globalObject$locatio3.protocol,
        f_url_param: this._encodeUrl(((_globalObject$locatio4 = globalObject.location) === null || _globalObject$locatio4 === void 0 ? void 0 : _globalObject$locatio4.href) || '').split('?')[1] || '',
        f_ref: this._encodeUrl(((_globalObject$documen = globalObject.document) === null || _globalObject$documen === void 0 ? void 0 : _globalObject$documen.referrer) || ''),
        f_platform: "".concat(env.os, ".").concat(env.app)
      }, options), true));
    }

    /**
     * 用于异步上报，由业务自己控制上报时机
     */
  }, {
    key: "ready",
    value: function ready() {
      this._isInit = true;
      this._handleQueue();
    }
  }, {
    key: "report",
    value: function report(params) {
      var loginType = cookie.get('main_login');
      var _params = _objectSpread({
        f_logintype: loginType && loginType !== 'none' ? loginType : '-',
        f_uid: (loginType === 'qq' ? cookie.get('vqq_openid') || getUin() : '') || cookie.get('openid'),
        f_vuid: (loginType === 'qq' ? cookie.get('vqq_vuserid') : '') || cookie.get('vuserid'),
        f_appid: (loginType === 'qq' ? cookie.get('vqq_appid') : '') || cookie.get('appid')
      }, params);
      if (!this._isInit) {
        this._queue.push(_params);
      } else {
        this.boss.report(_params);
      }
    }
  }, {
    key: "_handleQueue",
    value: function _handleQueue() {
      var _this = this;
      if (this._isInit) {
        Array.isArray(this._queue) && this._queue.forEach(function (v) {
          _this.boss.report(v);
        });
        this._queue = [];
      }
    }
  }, {
    key: "_encodeUrl",
    value: function _encodeUrl(url) {
      try {
        url = decodeURIComponent(url);
      } catch (e) {}
      return this.boss._encodeDollor(url);
    }
  }]);
  return Reporter;
}();
export { Reporter as default };